// app-service writes naive ISO-8601 (USE_TZ off) whose instant is UTC by convention, so a value
// without an offset is pinned to `Z` before parsing — `new Date()` on a naive string would read it
// in the browser's zone, which is the mistake ADR 0011 exists to prevent.
const HAS_OFFSET = /(?:Z|[+-]\d{2}:?\d{2})$/i;

// The exclusion has no «buzón» to borrow a zone from, so the caller hands in the panel's own —
// Madrid for the Spanish panel, London for the UK one (a bounded exception to ADR 0011's locker
// rule); `null`, a panel that cannot name its country, renders in UTC rather than guessing. `Intl`
// throws on a zone it does not know, and the raw string is a better answer than a crash in a render.
export function formatSince(iso: string, timeZone: string | null): string {
  const date = new Date(HAS_OFFSET.test(iso) ? iso : `${iso}Z`);
  if (Number.isNaN(date.getTime())) return iso;
  try {
    return new Intl.DateTimeFormat('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: timeZone ?? 'UTC',
    }).format(date);
  } catch {
    return iso;
  }
}
